/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_li_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free Lorem Ipsum generator. Create placeholder text by paragraphs, sentences or words, optionally starting with the classic 'Lorem ipsum dolor…'. Copy instantly.`)
};

const es_li_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generador gratuito de Lorem Ipsum. Crea texto de marcador por párrafos, oraciones o palabras, opcionalmente comenzando con el clásico "Lorem ipsum dolor…". Copia al instante.`)
};

const de_li_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser Lorem Ipsum Generator. Erstellen Sie Platzhaltertext nach Absätzen, Sätzen oder Wörtern und starten Sie optional mit dem klassischen "Lorem ipsum dolor…". Sofort kopieren.`)
};

const nl_li_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis Lorem Ipsum-generator. Maak plaatsaanduidingstekst per alinea, zin of woord, optioneel beginnend met de klassieke 'Lorem ipsum dolor…'. Kopieer direct.`)
};

const fr_li_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Générateur Lorem Ipsum gratuit. Créez du texte de remplissage par paragraphes, phrases ou mots, en commençant optionnellement par le classique "Lorem ipsum dolor…". Copiez instantanément.`)
};

const it_li_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generatore di Lorem Ipsum gratuito. Crea testo placeholder per paragrafi, frasi o parole, facoltativamente iniziando con il classico 'Lorem ipsum dolor…'. Copia istantaneamente.`)
};

const pt_br2_li_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerador de Lorem Ipsum gratuito. Crie texto de espaço reservado por parágrafos, frases ou palavras, opcionalmente começando com o clássico 'Lorem ipsum dolor…'. Copie instantaneamente.`)
};

const pt_li_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerador Lorem Ipsum gratuito. Crie texto espaço reservado por parágrafos, frases ou palavras, começando opcionalmente com o clássico 'Lorem ipsum dolor…'. Copie instantaneamente.`)
};

const ja_li_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料のLorem Ipsum生成器。段落、文、単語でプレースホルダーテキストを作成し、古典的な「Lorem ipsum dolor…」で始めることもできます。即座にコピー可能です。`)
};

const zh_li_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费的Lorem Ipsum生成器。按段落、句子或单词创建占位文本，可选择以经典的“Lorem ipsum dolor…”开头。即时复制。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const li_meta_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.li_meta_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("li_meta_description", locale)
	if (locale === "en") return en_li_meta_description(inputs)
	if (locale === "es") return es_li_meta_description(inputs)
	if (locale === "de") return de_li_meta_description(inputs)
	if (locale === "nl") return nl_li_meta_description(inputs)
	if (locale === "fr") return fr_li_meta_description(inputs)
	if (locale === "it") return it_li_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_li_meta_description(inputs)
	if (locale === "pt") return pt_li_meta_description(inputs)
	if (locale === "ja") return ja_li_meta_description(inputs)
	return zh_li_meta_description(inputs)
};